import React from "react";
import StyledButton from "../styledButton/StyledButton";

import styles from "./Placeholder.module.scss";

type PlaceholderProps = {
  image: string;
  title: string;
  text: string;
  button?: boolean;
  buttonText?: string;
  onClick?: () => void;
};

export default function Placeholder({
  image,
  title,
  text,
  button = false,
  buttonText = "",
  onClick = () => {},
}: PlaceholderProps) {
  return (
    <div className={styles.card}>
      <img className={styles.image} src={image} alt={title} />
      <p className={styles.title}>{title}</p>
      <p className={styles.text}>{text}</p>
      {button && <StyledButton text={buttonText} onClick={onClick} />}
    </div>
  );
}
